"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.removeL1Scroll = exports.handleScrollOnHover = exports.addL1Scroll = void 0;
var _react = _interopRequireDefault(require("react"));
var ON_SCROLL = 'on-scrollbar';
var NAV_L1_SELECTOR = '#cmp-navigation__ul_group';
var addL1Scroll = function addL1Scroll() {
  var _navigationL1$classLi;
  var navigationL1 = document.querySelector(NAV_L1_SELECTOR);
  if ((navigationL1 == null ? void 0 : (_navigationL1$classLi = navigationL1.classList) == null ? void 0 : _navigationL1$classLi.contains(ON_SCROLL)) === false) {
    navigationL1.classList.add(ON_SCROLL);
  }
};
exports.addL1Scroll = addL1Scroll;
var removeL1Scroll = function removeL1Scroll() {
  var _navigationL1$classLi2;
  var navigationL1 = document.querySelector(NAV_L1_SELECTOR);
  if ((navigationL1 == null ? void 0 : (_navigationL1$classLi2 = navigationL1.classList) == null ? void 0 : _navigationL1$classLi2.contains(ON_SCROLL)) === true) {
    navigationL1.classList.remove(ON_SCROLL);
  }
};
exports.removeL1Scroll = removeL1Scroll;
var handleScrollOnHover = function handleScrollOnHover(hasL2) {
  return hasL2 ? removeL1Scroll() : addL1Scroll();
};
exports.handleScrollOnHover = handleScrollOnHover;